export default __webpack_public_path__ + "static/media/playstation.25b0c183.svg";